export const Types = {
  GET_ACCOUNT_DETAILS_SUCCESS: 'GET_ACCOUNT_DETAILS_SUCCESS',
  GET_ACCOUNT_DETAILS_ERROR: 'GET_ACCOUNT_DETAILS_ERROR',
  GET_ACCOUNT_DETAILS: 'GET_ACCOUNT_DETAILS',
}
